import React, { useEffect, useState } from 'react'
import { API_URL } from '../../env'
import '../../styles/Payment/Payment.css'
import { ThreeCircles } from 'react-loader-spinner'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import { toast } from 'react-toastify'
import { Helmet } from 'react-helmet'

function Payment() {

    const { paymentToken } = useParams()
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {

        getPaymentLink()

    }, [])

    function getPaymentLink() {

        axios.put(API_URL + 'payment/pay', {
            paymentToken: paymentToken,
        }).then((response) => {
            if (response.data.message === 'PAYMENT_IN_PROGRESS') {
                window.location.href = response.data.paymentURL
            }
            setIsLoading(false)
        }).catch((error) => {
            if (error.response) {
                var errorMessage = error.response.data.message
                if (errorMessage === "ERROR_PAYMENT_NOT_FOUND") {
                    errorMessage = "Le paiement est introuvable"
                } else if (errorMessage === "ERROR_PAYMENT_IN_PROGRESS") {
                    errorMessage = "Le paiement est déjà en cours de traitement"
                } else if (errorMessage === "ERROR_PAYMENT_REFUSED") {
                    errorMessage = "Le paiement a déjà été refusé"
                } else if (errorMessage === "ERROR_PAYMENT_PAID") {
                    errorMessage = "Le paiement a déjà été payé"
                } else if (errorMessage === "ERROR_PAYMENT_EXPIRED") {
                    errorMessage = "La demande de paiement a expiré"
                } else if (errorMessage === "ERROR_STRIPE_CREATION") {
                    errorMessage = "Erreur lors de la création du paiement"
                } else if (errorMessage === "ERROR_PAYMENT_UPDATE") {
                    errorMessage = "Erreur lors de la mise à jour du paiement"
                } else if (errorMessage === "FORBIDDEN") {
                    errorMessage = "Le lien est incorrect"
                }
            }
            toast.error(errorMessage)
            setIsLoading(false)
        })

    }

    if (isLoading) {
        return (

            <>
                <Helmet>
                    <meta name="robots" content="noindex, nofollow" />
                    <meta name="title" content="Paiement - E5M Diagnostics" />
                    <meta name="description" content="Paiement de E5M Diagnostics." />
                </Helmet>

                <ThreeCircles visible={true} height={"100"} width={"100"} color={getComputedStyle(document.documentElement).getPropertyValue('--loaderDark')} wrapperClass={"loader"} />
            </>

        )
    } else {
        return (

            null

        )
    }

}

export default Payment